import React, { useState } from 'react'
import { Collapse } from 'reactstrap'
import TicketSvg from '../../../assets/icons/TicketSvg'
import CurtainsSvg from '../../../assets/icons/CurtainsSvg'
import CalenderSvg from '../../../assets/icons/CalenderSvg'
import ClockSvg from '../../../assets/icons/ClockSvg'
import Ticket8Svg from '../../../assets/icons/Ticket8Svg'

const HistoryItem = ({ title, name, date, seans, ticketNumbers, countTicketNumber, biletler = [], iptalSuresiSaat = 24, onIptal }) => {
  const [isOpen, setIsOpen] = useState(false)
  // Satır içi onay: uygulama içi tarayıcıda window.confirm her zaman görünmüyor.
  const [onayBiletId, setOnayBiletId] = useState(null)

  const gecerliBiletler = biletler.filter((b) => !b.iptal)
  const iptalEdilebilirVar = biletler.some((b) => b.iptal_edilebilir)

  const toggleApp = () => setIsOpen(!isOpen)

  return (
    <>
      <div
        className='applications'
        onClick={toggleApp}
        style={{
          transition: 'border-color 0.8s ease',
          boxShadow: 'none',
          borderColor: '#efefe7',
        }}
      >
        <div className='applications-text'>
          <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                borderRadius: '50%',
                padding: '0.8rem',
                background: 'radial-gradient(#FFCA61,#EE672B)',
              }}
            >
              <TicketSvg width={'1rem'} height={'1rem'} focus={false} />
            </div>
            <p style={{ margin: 0, fontWeight: 'normal' }}>{title}</p>
          </div>

          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              borderRadius: '5px',
              backgroundColor: '#EE672B',
            }}
          >
            <div
              style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                minWidth: '4rem',
                minHeight: '2rem',
                fontSize: '11px',
                color: '#fff',
              }}
            >
              {isOpen ? 'Gizle' : 'Detaylar'}
            </div>
          </div>
        </div>
      </div>
      <div className='userInfoDiv'>
        <Collapse isOpen={isOpen}>
          <div>
            <div
              style={{
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
                justifyContent: 'flex-start',
                fontSize: '14px',
                backgroundColor: '#F3F3F3',
                width: '90vw',
                padding: '0.35rem 0.5rem',
              }}
            >
              <CurtainsSvg width={'1rem'} height={'1rem'} focus={false} />
              <div style={{ fontWeight: '700', marginLeft: '10px', marginRight: '2.5px' }}>Gösteri Adı:</div>
              <div>{name}</div>
            </div>
            <div
              style={{
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
                justifyContent: 'flex-start',
                fontSize: '14px',
                backgroundColor: '#fff',
                width: '90vw',
                padding: '0.35rem 0.4rem',
                border: '1px solid #f3f3f3',
              }}
            >
              <CalenderSvg width={'1rem'} height={'1rem'} focus={false} />
              <div style={{ fontWeight: '700', marginLeft: '10px', marginRight: '2.5px' }}>Tarih:</div>
              <div>{date}</div>
            </div>
            <div
              style={{
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
                justifyContent: 'flex-start',
                fontSize: '14px',
                backgroundColor: '#F3F3F3',
                width: '90vw',
                padding: '0.35rem 0.5rem',
              }}
            >
              <ClockSvg width={'1rem'} height={'1rem'} focus={false} />
              <div style={{ fontWeight: '700', marginLeft: '10px', marginRight: '2.5px' }}>Seans: </div>
              <div>{seans}</div>
            </div>
            <div
              style={{
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
                justifyContent: 'flex-start',
                fontSize: '14px',
                backgroundColor: '#fff',
                width: '90vw',
                padding: '0.35rem 0.4rem',
                border: '1px solid #f3f3f3',
              }}
            >
              <Ticket8Svg width={'1rem'} height={'1rem'} focus={false} />
              <div style={{ fontWeight: '700', marginLeft: '10px', marginRight: '2.5px' }}>{countTicketNumber > 1 ? "Bilet Numaraları" : "Bilet Numarası"}:</div>
              <div>{ticketNumbers}</div>
            </div>

            {/* Bilet iptali: numara bir daha verilmez, koltuk boşalır */}
            {biletler.length > 0 && (
              <div style={{ width: '90vw', padding: '0.6rem 0.5rem', fontSize: '13px', borderBottom: '1px solid #f3f3f3' }}>
                {biletler
                  .filter((b) => b.iptal)
                  .map((b) => (
                    <div key={b.id} style={{ color: '#9b9b9b', marginBottom: '0.3rem' }}>
                      <span style={{ textDecoration: 'line-through' }}>#{b.bilet_no}</span> numaralı bilet iptal edildi.
                    </div>
                  ))}

                {gecerliBiletler
                  .filter((b) => b.iptal_edilebilir)
                  .map((b) =>
                    onayBiletId === b.id ? (
                      <div key={b.id} style={{ backgroundColor: '#FDECEC', borderRadius: '8px', padding: '0.5rem', marginBottom: '0.4rem' }}>
                        <div style={{ color: '#9B1C1C', marginBottom: '0.4rem' }}>#{b.bilet_no} numaralı bileti iptal etmek istediğinize emin misiniz? Bu işlem geri alınamaz.</div>
                        <div style={{ display: 'flex', gap: '0.5rem' }}>
                          <button type='button' onClick={() => setOnayBiletId(null)} style={{ flex: 1, border: '1px solid #d0d0d0', background: '#fff', borderRadius: '6px', padding: '0.35rem' }}>
                            Vazgeç
                          </button>
                          <button
                            type='button'
                            onClick={() => {
                              setOnayBiletId(null)
                              onIptal && onIptal(b)
                            }}
                            style={{ flex: 1, border: 'none', background: '#C81E1E', color: '#fff', borderRadius: '6px', padding: '0.35rem' }}
                          >
                            Evet, iptal et
                          </button>
                        </div>
                      </div>
                    ) : (
                      <button
                        key={b.id}
                        type='button'
                        onClick={() => setOnayBiletId(b.id)}
                        style={{ display: 'block', width: '100%', marginBottom: '0.4rem', border: '1px solid #C81E1E', color: '#C81E1E', background: '#fff', borderRadius: '6px', padding: '0.4rem' }}
                      >
                        #{b.bilet_no} numaralı bileti iptal et
                      </button>
                    ),
                  )}

                {gecerliBiletler.length > 0 && !iptalEdilebilirVar && (
                  <div style={{ color: '#7a7a7a' }}>Biletler etkinliğe {iptalSuresiSaat} saat kalana kadar iptal edilebilir.</div>
                )}
              </div>
            )}
          </div>
        </Collapse>
      </div>
    </>
  )
}

export default HistoryItem
